export default __webpack_public_path__ + "static/media/loading-icon.d6e80dd5.svg";